import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";
import ReminderStagesEditor from "@/components/ReminderStagesEditor";

export default function TenantReminderDialog({ open, onOpenChange, tenantId }) {
  const [custom, setCustom] = useState(false);
  const [stages, setStages] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && tenantId) {
      api.get(`/tenants/${tenantId}/reminder-stages`).then((r) => { setCustom(!!r.data.custom); setStages(r.data.stages || []); }).catch(() => {});
    }
  }, [open, tenantId]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/tenants/${tenantId}/reminder-stages`, { custom, stages });
      toast.success(custom ? "Eigen herinneringsschema opgeslagen" : "Terug op standaardschema");
      onOpenChange(false);
    } catch { toast.error("Opslaan mislukt"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto" data-testid="tenant-reminder-dialog">
        <DialogHeader>
          <DialogTitle>Herinneringsschema voor deze debiteur</DialogTitle>
          <DialogDescription>Stel afwijkende herinnerings-momenten en teksten in, of gebruik het standaardschema uit Instellingen.</DialogDescription>
        </DialogHeader>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={custom} onChange={(e) => setCustom(e.target.checked)} data-testid="tenant-reminder-custom-toggle" />
          Eigen herinneringsschema voor deze debiteur gebruiken
        </label>
        {custom ? (
          <ReminderStagesEditor stages={stages} setStages={setStages} />
        ) : (
          <p className="text-sm text-slate-500 border rounded-lg p-4 bg-slate-50">Deze debiteur volgt het standaard herinneringsschema uit Instellingen → Herinneringen.</p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuleren</Button>
          <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={save} disabled={saving} data-testid="tenant-reminder-save">{saving ? "Opslaan…" : "Opslaan"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
